module.exports = __webpack_public_path__ + "img/towel_2.f60b01ae.png";